// One source for the per-theme card styling shared by the home screen's Fresh
// and Featured cards. Before this, ThemeSelection.jsx and FeaturedCaseCard.jsx
// each kept their own copy; the values already agreed and are merged verbatim.
// Every class is a literal so Tailwind's content scanner emits it.
export const THEME_STYLES = {
  noir: {
    label: 'Film Noir',
    gradient: 'from-slate-900 to-slate-800',
    border: 'border-[#DC143C]/40',
    hoverBorder: 'hover:border-[#DC143C]',
    accentText: 'text-[#DC143C]',
    focusRing: 'focus-visible:after:ring-[#DC143C]',
    accentRgb: '220, 20, 60',
  },
  '90s_nyc': {
    label: '90s NYC',
    gradient: 'from-orange-900 to-blue-900',
    border: 'border-orange-500/40',
    hoverBorder: 'hover:border-orange-500',
    accentText: 'text-orange-400',
    focusRing: 'focus-visible:after:ring-orange-400',
    accentRgb: '255, 107, 53',
  },
  miami_vice: {
    label: 'Miami Vice',
    gradient: 'from-purple-900 via-pink-800 to-cyan-900',
    border: 'border-pink-500/40',
    hoverBorder: 'hover:border-pink-500',
    accentText: 'text-pink-400',
    focusRing: 'focus-visible:after:ring-pink-400',
    accentRgb: '255, 20, 147',
  },
};

export const getThemeStyle = (themeId) => THEME_STYLES[themeId] || THEME_STYLES.noir;
